/**
 * @see https://umijs.org/docs/max/access
 * 权限定义
 */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};

  return {
    // 超级管理员
    canAdmin: currentUser?.superAdmin === true || currentUser?.access === 'SUPER_ADMIN',
    // 系统管理权限
    canManageUser: currentUser?.superAdmin === true || ['SUPER_ADMIN', 'COMPANY_ADMIN', 'DEPARTMENT_ADMIN'].includes(currentUser?.access || ''),
    // 数据范围由平台或公司管理员配置，部门负责人不可修改授权边界。
    canManageDataScope: currentUser?.superAdmin === true || ['SUPER_ADMIN', 'COMPANY_ADMIN'].includes(currentUser?.access || ''),
    // 组织查看权限（部门负责人也可查看本部门组织）
    canViewOrganization: currentUser?.superAdmin === true || ['SUPER_ADMIN', 'COMPANY_ADMIN', 'DEPARTMENT_ADMIN'].includes(currentUser?.access || ''),
    // 操作日志接口只授权平台/公司管理员；不能让部门负责人看到入口后再收到 403。
    canViewOperationLogs: currentUser?.superAdmin === true || ['SUPER_ADMIN', 'COMPANY_ADMIN'].includes(currentUser?.access || ''),
    // 菜单权限
    hasMenu: (menuKey: string) => {
      if (currentUser?.superAdmin) return true;
      return currentUser?.menus?.includes(menuKey) ?? false;
    },
  };
}
